/**
 * AP-35 Nachtrag 17 (Detailblatt 5 5.3b b) — **Fenster „Angebote übernehmen"** aus der Stückliste: der Preisspiegel
 * des Einkaufs (AP-39 10.4) für diese Position, auf Wunsch für das ganze Projekt. Gewählt, verglichen und übernommen
 * wird wie im Reiter „Preisspiegel" — dieselbe Ansicht, dieselbe Vorschau, dasselbe Schreiben (N17-1, N17-2).
 */
import { useState } from 'react'
import { X } from 'lucide-react'
import { useTerminology } from '@/lib/useTerminology'
import { OfferComparisonTab } from './OfferComparisonTab'

export function AngeboteFenster({
  projectId,
  positionId,
  onClose,
  onGeaendert,
}: {
  projectId: string
  positionId: string
  onClose: () => void
  /** nach dem Übernehmen — die Stückliste lädt neu, das Fenster schließt */
  onGeaendert: () => void
}) {
  const terms = useTerminology()
  const [alle, setAlle] = useState(false)
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4" role="dialog" aria-modal="true" aria-label="Angebote übernehmen">
      <div className="max-h-[90vh] w-full max-w-6xl space-y-3 overflow-auto rounded-lg border border-border p-5 shadow-xl" style={{ background: 'hsl(var(--card))', color: 'hsl(var(--card-foreground))' }}>
        <div className="flex items-start justify-between gap-3">
          <div>
            <h2 className="text-lg font-semibold">Angebote übernehmen</h2>
            <p className="text-sm text-muted-foreground">
              Die Angebote der Lieferanten zu {alle ? `allen ${terms.positionPlural}` : `dieser ${terms.position}`} — der günstigste je Zeile ist gewählt. Erfasst und bestätigt wird die Antwort an der
              Preisanfrage.
            </p>
          </div>
          <button type="button" className="rounded p-1 text-muted-foreground hover:bg-muted hover:text-foreground" onClick={onClose} aria-label="Fenster schließen">
            <X size={16} />
          </button>
        </div>
        <label className="flex items-center gap-1.5 text-sm">
          <input type="checkbox" checked={alle} onChange={(e) => setAlle(e.target.checked)} />
          alle {terms.positionPlural}
        </label>
        <OfferComparisonTab projectId={projectId} positionId={alle ? undefined : positionId} onGeaendert={onGeaendert} />
      </div>
    </div>
  )
}
